import type { ActivationObjectSchema } from "app/pages/activation";

import type { BenchmarkDataType } from "../types/api.types";

export enum BenchmarkPrimaryEntityType {
    WEBSITE = "WEBSITE",
}

type PrimaryEntity = {
    id: string;
    name: string;
    segmentName?: string;
    image: string;
    type: BenchmarkPrimaryEntityType;
    activationSet?: ActivationObjectSchema;
    rank?: number;
};

export type BenchmarkType = BenchmarkDataType & PrimaryEntity;

export type TableDataSchema = {
    domain: string;
    audienceReach?: number;
    mom?: number;
    trends?: Array<{ key: number; value: number | string }>;
    defaultIcon?: string;
    isPrimary: boolean;
    rank?: number;
    isOtherCompetitors?: boolean;
};

export type StructuredChartDataSchema = {
    name: string;
    data: Array<{ y: number; diff?: number }>;
    color: string;
};

export type ChartDataSchema = {
    structuredChartData: StructuredChartDataSchema[];
    dates: string[];
};
